import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      merchantSettings: 'merchant/settings',
    }),
    merchantId() {
      let merchantId;
      if (this.$route.params.merchant_id) {
        // Used for settings on the merchant pages
        merchantId = this.$route.params.merchant_id;
      } else {
        // Used for settings on business list and similar
        merchantId = this.merchant.id;
      }
      return merchantId;
    },
  },
  mounted() {
    this.fetchSettings(this.merchantId);
  },
  methods: {
    ...mapActions({
      fetchSettings: 'merchant/fetchSettings',
      updateAvailability: 'merchant/updateAvailability',
    }),
    changeMerchantAvailability(available) {
      const payload = {
        merchant_id: this.merchantId,
        data: {
          available,
        },
      };

      this.updateAvailability(payload);
    },
  },
};
